import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Button from '../components/Button';

export default function Login() {
  const { user, login, loginWithGoogle } = useAuth(); // ⭐ added loginWithGoogle
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/games';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState('');

  const btnRef = useRef(null);
  const [scriptReady, setScriptReady] = useState(!!window.google);

  useEffect(() => {
    if (user) navigate('/playable', { replace: true });
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // --- load the Google script once ---
  useEffect(() => {
    if (window.google) {
      setScriptReady(true);
      return;
    }
    const s = document.createElement('script');
    s.src = 'https://accounts.google.com/gsi/client';
    s.async = true;
    s.defer = true;
    s.onload = () => setScriptReady(true);
    document.head.appendChild(s);
  }, []);

  // --- initialize and render the button once ready ---
  useEffect(() => {
    if (!scriptReady || !btnRef.current) return;

    const onCredential = (res) => {
      fetch('https://kepithorstudios.com/google-login.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          id_token: res.credential,
        }),
      })
        .then((r) => r.json())
        .then((data) => {
          console.log('Backend responded:', data);

          if (data.response === 'loginSuccessFul') {
            // Build user object compatible with AuthContext
            const googleUser = {
              id: data.id,
              displayname: data.displayname,
              email: data.email,
              session: data.session,
              hash: data.hash,
            };

            // optional – if you still want these:
            localStorage.setItem('session', data.session);
            localStorage.setItem('hash', data.hash);

            // ⭐ use AuthContext helper instead of setUserData
            loginWithGoogle(googleUser);

            // go to games (or wherever you like)
            navigate('/games', { replace: true });
          } else {
            setFormError(data.message || 'Google login failed');
          }
        })
        .catch((error) => {
          console.error('Login request failed:', error);
          setFormError('Network error: ' + error.message);
        });
    };

    window.google.accounts.id.initialize({
      client_id:
        '200275950253-qdgu6i747qbe7p7bc1fdjsp9l3uaiacl.apps.googleusercontent.com',
      callback: onCredential,
      use_fedcm_for_prompt: true,
    });

    window.google.accounts.id.renderButton(btnRef.current, {
      type: 'standard',
      theme: 'outline',
      size: 'large',
    });
  }, [scriptReady, loginWithGoogle, navigate]);

  return (


    <>
    
        <div className="spacer" style={{height: 20}}></div>
    
    <div className="mx-auto max-w-md bg-slate-900/70 border border-slate-800 rounded-2xl p-6 shadow-xl shadow-emerald-500/10">
      <h1 className="text-2xl font-bold mb-4">Sign in</h1>
      <form onSubmit={handleSubmit} className="grid gap-3">
        <label className="grid gap-1">
          <span className="text-sm text-slate-300">Email</span>
          <input
            className="border border-slate-700 bg-slate-950/60 rounded-xl px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>

        <label className="grid gap-1">
          <div className="flex items-center justify-between">
            <span className="text-sm text-slate-300">Password</span>
            {/* ⭐ Forgot password link */}
            <Link
              to="/forgot-password"
              className="text-xs text-emerald-300 hover:text-emerald-200 underline"
            >
              Forgot password?
            </Link>
          </div>
          <input
            className="border border-slate-700 bg-slate-950/60 rounded-xl px-3 py-2 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>

        {error && <div className="text-red-400 text-sm">{error}</div>}
        {formError && <div className="text-red-400 text-sm">{formError}</div>}

        <Button
          disabled={loading}
          className="bg-emerald-500 text-grey hover:bg-emerald-400"
        >
          {loading ? 'Signing in…' : 'Sign in'}
        </Button>

        <div className="text-sm mt-2 text-slate-300">
          No account?{' '}
          <Link to="/register" className="text-emerald-300 underline">
            Create one
          </Link>
        </div>
      </form>

      <div className="mt-4 border-t border-slate-800 pt-4">
        <div className="text-center text-sm text-slate-400 mb-2">or</div>
        <div className="flex justify-center">
          <div ref={btnRef} />
        </div>
      </div>
    </div>
    
    </>
    
  );
}
